<template>
    <v-content class="login">
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                    <v-toolbar dark color="#3851dd">
                        <v-toolbar-title>Login form</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-form validate>
                            <v-text-field prepend-icon="person" name="email" label="Login"
                                          type="email" v-model="email" :rules="emailRules"></v-text-field>
                            <v-text-field id="password" prepend-icon="lock" name="password" label="Password"
                                          type="password" v-model="password" :rules="passwordRules"></v-text-field>
                        </v-form>
                        <p v-if="feedback" class="red--text">{{feedback}}</p>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#3851dd" @click.prevent="login">Login</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-content>
</template>

<script>
    import firebase from 'firebase'

    export default {
        name: "Login",
        data: () => ({
            valid: true,
            password: null,
            passwordRules: [
                v => !!v || 'Password is required'
            ],
            email: '',
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
            feedback: null
        }),
        methods: {
            login() {
                if (this.email && this.password) {
                    firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
                        (cred) => {
                            this.$router.push({name: 'UserHome', params: {email: this.email}})
                        }
                    ).catch(
                        err => this.feedback = err.message
                    )
                    this.feedback = null
                }
                else {
                    this.feedback = 'Please fill in email and password'
                }
            }
        }
    }
</script>

<style>
    .login {
        margin-top: 50px;
        height: 400px;
    }
</style>


// WEBPACK FOOTER //
// src/components/auth/Login.vue